const initialState = {

   
    loading: false,
    news: []
}

const news = (state = initialState , action) => {

    switch(action.type) {
        case 'FETCH_NEWS':
           //return state.posts =  action.payload
          return {...state,...{loading: true },...action.payload}
      
         case 'UPDATE_NEWS':
            //return {...state,...{loading: true },...action.payload}
            return {...state,...{loading: true },...action.payload}
            
        default:
            return state
    }
}

export default news